import { render, staticRenderFns } from "./InformationBody.vue?vue&type=template&id=dc9bcbbe&"
import script from "./InformationBody.vue?vue&type=script&lang=js&"
export * from "./InformationBody.vue?vue&type=script&lang=js&"
import style0 from "./InformationBody.vue?vue&type=style&index=0&id=dc9bcbbe&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports